// generated by genversion
export var version = '3.8.15';
//# sourceMappingURL=version.js.map